import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-b14eddb2")

_pushScopeId("data-v-b14eddb2")
const _hoisted_1 = { class: "error-404" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = /*#__PURE__*/_createVNode("p", { class: "sup" }, "Sorry, the page you are looking for cannot be found!", -1)
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Please ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("click here")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" to return to our homepage. ")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_GridLine = _resolveComponent("GridLine")
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_GridLine),
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode("p", null, [
        _hoisted_4,
        _createVNode(_component_router_link, {
          to: "/",
          class: "return-to-home"
        }, {
          default: _withId(() => [
            _hoisted_5
          ]),
          _: 1
        }),
        _hoisted_6
      ])
    ])
  ]))
})